export const ActionTypes = {
  SET_VOUCHERSLIST: "SET_VOUCHERSLIST",
  SELECTED_VOUCHERS: "SELECTED_VOUCHERS",
  SET_PAYMENT_RUT: "SET_PAYMENT_RUT",
};
